import { render, staticRenderFns } from "./lolth-dialog.vue?vue&type=template&id=006e8d5a&scoped=true&"
import script from "./lolth-dialog.vue?vue&type=script&lang=ts&"
export * from "./lolth-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./lolth-dialog.vue?vue&type=style&index=0&id=006e8d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006e8d5a",
  null
  
)

/* custom blocks */
import block0 from "./lolth-dialog.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports